/* START_MODULE build_config */
/* START_CONTRACT
PURPOSE: Resolve build-time deployment configuration, including locale-owned canonical origins, from VITE_* environment variables.
MATHEMATICAL_SCOPE: Deployment configuration only; it must not alter mathematical claims.
PUBLIC_SURFACE: SINGLE_LOCALE, SITE_ORIGIN, siteOriginForLocale.
KEYWORDS: config, deploy, single-locale, canonical-origin, locale-origin
COMPLEXITY: 1
END_CONTRACT */

import type { Locale } from "./i18n";

function envValue(key: string): string | undefined {
  const viteEnv = (import.meta as { env?: Record<string, string | undefined> })
    .env?.[key];
  if (viteEnv !== undefined) return viteEnv;
  const nodeProcess = (
    globalThis as { process?: { env?: Record<string, string | undefined> } }
  ).process;
  return nodeProcess?.env?.[key];
}

const rawSingleLocale = envValue("VITE_SINGLE_LOCALE");
const rawSiteOrigin = envValue("VITE_SITE_ORIGIN");

export const SINGLE_LOCALE: Locale | null = (() => {
  if (!rawSingleLocale) return null;
  if (rawSingleLocale === "ru" || rawSingleLocale === "en") {
    return rawSingleLocale;
  }
  throw new Error(
    `VITE_SINGLE_LOCALE must be "ru" or "en", got ${JSON.stringify(rawSingleLocale)}`,
  );
})();

export const SITE_ORIGIN: string =
  rawSiteOrigin ?? "https://magic-squares.mynka.tech";

/* START_FUNCTION siteOriginForLocale */
/* START_CONTRACT
PURPOSE: Map each public locale to the host that owns its canonical pages.
CONTRACT: A build-wide VITE_SITE_ORIGIN override wins for single-edition builds; otherwise English uses the international host and Russian uses the RU host.
FAILURE_MEANING: Search metadata may split one locale across duplicate canonical hosts.
KEYWORDS: locale, origin, canonical, deployment
COMPLEXITY: 1
END_CONTRACT */
export function siteOriginForLocale(locale: Locale): string {
  if (rawSiteOrigin) return rawSiteOrigin;
  return locale === "ru"
    ? "https://magic-squares.ru.mynka.tech"
    : SITE_ORIGIN;
}
/* END_FUNCTION siteOriginForLocale */

/* END_MODULE build_config */
